
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/hotel-offers",
      function () {
        return require("private-next-pages/[hid]/hotel-offers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/hotel-offers"])
      });
    }
  